export default "__VITE_ASSET__DzsypBox__"